import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cotizacion',
  templateUrl: './cotizacion.component.html',
  styleUrls: ['./cotizacion.component.scss']
})
export class CotizacionComponent implements OnInit {

  constructor() {}

  optionsBodega: Array<any> = [];
  optionsSucurcal: Array<any> = [];
  optionsCategoria: Array<any> = [];
  optionsFamilia: Array<any> = [];
  optionsMedida: Array<any> = [];

  ngOnInit() {
    this.optionsBodega = [
      { value: "1", label: "Bodega 1" },
      { value: "2", label: "Bodega 2" },
      { value: "3", label: "Bodega 3" },
    ];
    this.optionsSucurcal = [
      { value: "1", label: "Sucurcal 1" },
      { value: "2", label: "Sucurcal 2" },
      { value: "3", label: "Sucurcal 3" },
    ];
    this.optionsCategoria = [
      { value: "1", label: "Categoria 1" },
      { value: "2", label: "Categoria 2" },
      { value: "3", label: "Categoria 3" },
    ];
    this.optionsFamilia = [
      { value: "1", label: "Familia 1" },
      { value: "2", label: "Familia 2" },
      { value: "3", label: "Familia 3" },
    ];
    this.optionsMedida = [
      { value: "1", label: "Medida 1" },
      { value: "2", label: "Medida 2" },
      { value: "3", label: "Medida 3" },
    ];
  }
}
